import Ajax from '@utils/ajax';

export default {
  index() {
    return Ajax.get({
      url: '/nudges',
      withErrorHandling: false,
    });
  },

  update(data) {
    return Ajax.post({
      url: '/nudges/x',
      data: { nudge: data, _method: 'PUT' },
      withErrorHandling: false,
    });
  },
};
